                                                                                                                                                                                                    <template>
    <div class="app-container">
        <div class="filter-container">
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"
                          placeholder="上级部门ID，一级部门为0"
                          v-model="listQuery.parentId">
                </el-input>
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"
                          placeholder="部门名称"
                          v-model="listQuery.name">
                </el-input>
                            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item"
                          placeholder="排序"
                          v-model="listQuery.orderNum">
                </el-input>
                                        <el-select @change='handleFilter'  clearable class="filter-item" style="width: 130px" v-model="listQuery.delFlag"
                           placeholder="是否删除">
                                        <el-option v-for="(item,index) in  delFlagOptions" :key="item" :label="item" :value="index">
                    </el-option>
                </el-select>

            <el-button class="filter-item" type="primary" v-waves icon="el-icon-search" @click="handleFilter">查找
            </el-button>
            <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                       icon="el-icon-edit">添加
            </el-button>
            <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                       @click="handleDownload">导出
            </el-button>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;min-height:1000px;">
            <el-table-column align="center" label="序号">
                <template slot-scope="scope">
                    <span>{{scope.row.deptId}}</span>
                </template>
            </el-table-column>
                            <el-table-column align="center" label="上级部门ID，一级部门为0">
                    <template slot-scope="scope">
                        <span>{{scope.row.parentId}}</span>
                    </template>
                </el-table-column>
                            <el-table-column align="center" label="部门名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                            <el-table-column align="center" label="排序">
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNum}}</span>
                    </template>
                </el-table-column>
                                        <el-table-column align="center" label="是否删除">
                    <template slot-scope="scope">
                        <span>{{scope.row.delFlag}}</span>
                    </template>
                </el-table-column>

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.status!='deleted'" size="mini" type="danger"
                               @click="handleDelete(scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="70px"
                     style='width: 400px; margin-left:50px;'>
                                    <el-form-item label="上级部门ID，一级部门为0" prop="name">
                        <el-input v-model="temp.parentId"></el-input>
                    </el-form-item>
                                    <el-form-item label="部门名称" prop="name">
                        <el-input v-model="temp.name"></el-input>
                    </el-form-item>
                                    <el-form-item label="排序" prop="name">
                        <el-input v-model="temp.orderNum"></el-input>
                    </el-form-item>
                                                    <el-form-item label="是否删除" prop="status">
                        <el-select class="filter-item" v-model="temp.delFlag" placeholder="是否删除">
                            <el-option v-for="(item,index) in  delFlagOptions" :key="item" :label="item"
                                       :value="index">
                            </el-option>
                        </el-select>
                    </el-form-item>

                            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        padding-bottom: 20px;
    }
</style>

<script>
    import { list, save, update, remove } from '../../../api/sys_dept'
    import waves from '@/directive/waves' // 水波纹指令

    export default {
      name: 'test',
      directives: {
        waves
      },
      data() {
        return {
          tableKey: 0,
          list: null,
          total: null,
          listLoading: true,
          listQuery: {
            page: 1,
            limit: 20,
            sidx: 'dept_id',
            order: 'desc',
            parentId: null,
            name: null,
            orderNum: null,
            delFlag: null
          },
          delFlagOptions: ['已删除', '正常'],
          temp:
            {
              deptId: null, parentId: null, name: null, orderNum: null, delFlag: null },
          dialogFormVisible: false,
          dialogStatus:
            '',
          textMap:
            {
              update: '修改',
              create:
                '新增'
            },
          rules:
            {
              parentId: [
                {
                  required: false, message:
                                '必填字段', trigger:
                                'change'
                }
              ],
              name: [
                {
                  required: false, message:
                                '必填字段', trigger:
                                'change'
                }
              ],
              orderNum: [
                {
                  required: false, message:
                                '必填字段', trigger:
                                'change'
                }
              ],
              delFlag: [
                {
                  required: false, message:
                                '必填字段', trigger:
                                'blur'
                }
              ]
            },
          downloadLoading: false,
          qData:
            {
              token: '',
              key:
                ''
            }
        }
      },
      created() {
        this.getList()
      },
      methods: {
        getList() {
          this.listLoading = true
          list(this.listQuery).then(response => {
            this.list = response.data.list
            this.total = response.data.total
            this.listLoading = false
          })
        },
        handleFilter() {
          this.listQuery.page = 1
          this.getList()
        },
        handleSizeChange(val) {
          this.listQuery.limit = val
          this.getList()
        },
        handleCurrentChange(val) {
          this.listQuery.page = val
          this.getList()
        },
        handleModifyStatus(row, status) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          row.status = status
        },
        resetTemp() {
          this.temp = {}
        },
        handleCreate() {
          // 存在图片
          this.resetTemp()
          this.dialogStatus = 'create'
          this.dialogFormVisible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        },
        handleDelete(row) {
          this.temp = Object.assign({}, row) // copy obj
          this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // })
            this.deleteData()
          })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
        },
        createData() {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              save(this.temp).then(res => {
                this.temp = res.data
                this.list.unshift(this.temp)
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
          )
        },
        deleteData() {
          const ids = [this.temp.id]
          remove(ids).then(res => {
            // 从当前队列中移除
            for (const v of this.list
            ) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1)
                break
              }
            }
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success',
              duration: 2000
            })
          })
        },
        handleUpdate(row) {
          this.temp = Object.assign({}, row) // copy obj
          this.dialogStatus = 'update'
          this.dialogFormVisible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].clearValidate()
          })
        },
        updateData() {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              const tempData = Object.assign({}, this.temp)
              update(tempData).then(() => {
                for (const v of this.list
                ) {
                  if (v.id === this.temp.id) {
                    const index = this.list.indexOf(v)
                    this.list.splice(index, 1, this.temp)
                    break
                  }
                }
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
          )
        },
        closeDialogForm() {
          this.dialogFormVisible = false
        },
        handleDownload() {
          this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                  const tHeader = [
                    '序号',
                    '上级部门ID，一级部门为0',
                    '部门名称',
                    '排序',
                    '是否删除'
                  ]
                  const filterVal = ['id',
                    'parentId',
                    'name',
                    'orderNum',
                    'delFlag'
                  ]
                  const data = this.formatJson(filterVal, this.list)
                  excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: 'table-list'
                  })
                  this.downloadLoading = false
                })
        },
        formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => {
            return v[j]
          }
          ))
        }
      }
    }
</script>
